import React from 'react';
import { useTranslation } from '@/app/components/translations/Translation';
import { useSearchPageWrapperData } from '@/app/components/search/searchPageCommonWrapperProvider.tsx';
import { FILTER_NAME } from '@/app/common/filters/core/filterNames.ts';
import { FilterGroupPill } from '@/app/common/filters/surfaces/bar/pills/FilterGroupPill.tsx';
import type { CustomFilterGroupLabelCreators } from '@/app/common/filters/surfaces/forms/FilterGroupsComponents.tsx';
import { sortLabelCreator, createSortPill } from '@/app/common/filters/surfaces/bar/resultsPills/createSortPill.ts';
import { Spacer } from '@/app/common/components/Separator';
import SortFilterRadio from '@/app/common/filters/surfaces/SortFilterRadio.tsx';
import TotalPriceToggle from '@/app/common/components/TotalPriceToggle';
import { SortBarBadges, SortBarRow } from './styled.ts';
import { SortBarInfoBadges } from './SortBarInfoBadges';
import type { LayoutVariant } from './types';

export const ResultsSortBar = ({ variant, isLoading }: { variant?: LayoutVariant; isLoading?: boolean }) => {
  const { t } = useTranslation();
  const { filtersGroups, handleFilterChanged } = useSearchPageWrapperData();
  const sortFilterPill = createSortPill({ filtersGroups, t });

  return (
    <SortBarRow variant={variant}>
      <FilterGroupPill
        filterPill={sortFilterPill[0]}
        isLoading={false}
        busy={isLoading}
        handleFilterChanged={handleFilterChanged}
        key={sortFilterPill[0].label}
        customFilterMainCreators={{ [FILTER_NAME.SORT]: SortFilterRadio }}
        customFilterLabelCreators={
          { [FILTER_NAME.SORT]: () => sortLabelCreator(t, sortFilterPill[0]) } as CustomFilterGroupLabelCreators
        }
        closeOnScroll={true}
      />
      <TotalPriceToggle variant="filter" disabled={isLoading} />
      <Spacer />
      <SortBarBadges>
        <SortBarInfoBadges isLoading={isLoading} />
      </SortBarBadges>
    </SortBarRow>
  );
};
